"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./config");
var isFunction = function (val) {
    return typeof val === 'function';
};
exports.getDevToolSwitchStatus = function () {
    var result = false;
    if (typeof sessionStorage === 'object' && sessionStorage.getItem && isFunction(sessionStorage.getItem)) {
        result = Boolean(sessionStorage.getItem(config_1.default.devToolSwitchStorageName));
    }
    if (!result && typeof window === 'object' && window[config_1.default.devToolGlobalName]) {
        result = true;
    }
    return result;
};
exports.showComponentInfomation = function (nameAndVersion, propsData, defaultPropsData) {
    if (nameAndVersion === void 0) { nameAndVersion = {}; }
    if (propsData === void 0) { propsData = {}; }
    if (defaultPropsData === void 0) { defaultPropsData = {}; }
    var result = '', devToolIsOpen = exports.getDevToolSwitchStatus(), key = '', props = {};
    if (devToolIsOpen) {
        for (key in propsData) {
            if (defaultPropsData[key] != propsData[key]) {
                if (isFunction(propsData[key])) {
                    props[key] = '自定义函数';
                }
                else if (typeof propsData[key] === 'object' && propsData[key] && propsData[key].tagName) {
                    props[key] = 'dom节点';
                }
                else if (typeof propsData[key] === 'object' && propsData[key] && propsData[key].$$typeof) {
                    props[key] = 'jsx element节点';
                }
                else if (key === 'children') {
                    if (typeof propsData[key] === 'object') {
                        props[key] = 'React Children';
                    }
                    else {
                        props[key] = propsData[key];
                    }
                }
                else {
                    props[key] = propsData[key];
                }
            }
        }
        try {
            result = JSON.stringify(__assign({}, nameAndVersion, { props: props }));
        }
        catch (e) {
            result = e.message;
        }
    }
    return result;
};
exports.getComponentInfomation = function (nameAndVersion, propsData, defaultPropsData) {
    if (nameAndVersion === void 0) { nameAndVersion = {}; }
    if (propsData === void 0) { propsData = {}; }
    if (defaultPropsData === void 0) { defaultPropsData = {}; }
    var result = {}, devToolIsOpen = exports.getDevToolSwitchStatus(), key = '', props = {};
    if (devToolIsOpen) {
        for (key in propsData) {
            if (defaultPropsData[key] != propsData[key]) {
                props[key] = propsData[key];
            }
        }
        result = __assign({}, nameAndVersion, { props: props });
    }
    return result;
};
exports.default = {
    showComponentInfomation: exports.showComponentInfomation,
    getComponentInfomation: exports.getComponentInfomation,
    getDevToolSwitchStatus: exports.getDevToolSwitchStatus
};
